<template>
  <div id="login">
    <call />
    <!-- nav bot -->
    <footer-app page="top" hide="false"></footer-app>
    <top-bar title="アカウント連携" backUrl="/account/profile"/>
    <!-- main -->
    <main>
      <!-- login -->
      <div class="l-login">
        <div class="l-login__form">
          <div class="l-login__form--description text-center">
            お客さまがお持ちの <br>
            <template v-if="isIos">Apple、</template>Google、LINEのアカウントで<br>
            ログインできます。
          </div>
          <div class="l-login__form--sns">
            <a v-if="isIos" v-on:click="loginApple" href="javascript:void(0)" class="c-btn-sns c-btn-sns--apple">
              <div class="c-btn-sns__icon"><img src="/assets/images/icon/icon-apple.svg" alt="" height="26"></div>
              <div class="c-btn-sns__text">Appleでサインイン</div>
            </a>
            <a v-on:click="loginGoogle" href="javascript:void(0)" class="c-btn-sns c-btn-sns--google">
              <div class="c-btn-sns__icon"><img src="/assets/images/icon/icon-google.svg" alt="" height="28"></div>
              <div class="c-btn-sns__text">Googleアカウントでログイン</div>
            </a>
            <a v-on:click="loginLine" href="javascript:void(0)" class="c-btn-sns c-btn-sns--line">
              <div class="c-btn-sns__icon"><img src="/assets/images/icon/icon-line.svg" alt="" height="26"></div>
              <div class="c-btn-sns__text">LINEアカウントでログイン</div>
            </a>
            <div class="l-login__error-message" v-if="errorMessage.length > 0">
              <i> {{ errorMessage }}</i>
            </div>
          </div>
          <div class="l-login__form--privacy-policy mt-42">
            <router-link to="/about/privacy?is_back_btn=true">プライバシーポリシー</router-link>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Common, Login, eventBus } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getAllUserIds } from "../store/firestore.js";
import { DB } from "../config/const.js";
import firebase from "../common/firebaseProject.js";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "Login",
  components: {
    'footer-app': Footer,
    TopBar
  },
  mixins: [Tenant],
  data () {
    return  {
      isIos: Common.isIphone(),
      errorMessage: '',
      fromPage: '',
    }
  },
  created() {
    // どこからの画面遷移か確認
    this.fromPage = Common.getUrlParam('from-page');
    eventBus.$on('loginError', (message) => {
      console.log(message);
      this.alert("システムエラーのため、ログインできませんでした。");
    })
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async loginAnonymous (goToTop) {
      
      Common.loadingShow();

      const res = await firebase.auth().signInAnonymously()
      const user = res.user
      if (Object.keys(user).length != 0) {
        await this.checkUserExist(user.uid)
        this.$store.dispatch('checkLogin', user.uid)
        this.$store.dispatch('finishTutorial');
        if (goToTop){
          this.$router.push('/top');
        }
      } else {
        this.errorMessage = 'エラーが発生しました'
      }

      Common.loadingHide();

    },
    /**
     * 匿名ログイン
     */
    cancelLogin() {
      Common.loadingHide();
      if (this.fromPage && 0 < this.fromPage.length) {
        this.$router.push(this.fromPage);
        return;
      }
      this.loginAnonymous(true);
    },
    async loginApple() {
      try {
        if(!firebase.auth().currentUser){
          await this.loginAnonymous();
        }
        this.loadingShow();
        const idToken = await firebase.auth().currentUser.getIdToken();
        const callable = firebase.functions('asia-northeast1').httpsCallable('exchangeToken');
        const result = await callable({ idToken: idToken, authType: "anonymous" })
        .catch(e => {
          throw e;
        })
        console.log(result);
        if (result.data.status == 'SUCCEED'){
          this.$router.replace({query: { 'from-page': '/account/profile' }})
          Common.messageHandlers('apple_login', { customToken: result.data.firebaseToken });
        } else {
          Login.errorLoginProcess();
        }
      }catch (e){
        
        console.error(e);
      }
    },
    async loginGoogle() { 
      try {
        if(!firebase.auth().currentUser){
          await this.loginAnonymous();
        }
        this.loadingShow();
        const idToken = await firebase.auth().currentUser.getIdToken();
        const callable = firebase.functions('asia-northeast1').httpsCallable('exchangeToken');
        const result = await callable({ idToken: idToken, authType: "anonymous" })
        .catch(e => {
          throw e;
        })
        console.log(result);
        if (result.data.status == 'SUCCEED'){
          this.$router.replace({query: { 'from-page': '/account/profile' }})
          Common.messageHandlers('google_login', { customToken: result.data.firebaseToken });
        } else {
          Login.errorLoginProcess();
        }
      }catch (e){
        
        console.error(e);
      }
    },
    async loginLine() {
      try {
        if(!firebase.auth().currentUser){
          await this.loginAnonymous();
        }
        this.loadingShow();
        const idToken = await firebase.auth().currentUser.getIdToken();
        const callable = firebase.functions('asia-northeast1').httpsCallable('exchangeToken');
        const result = await callable({ idToken: idToken, authType: "anonymous" })
        .catch(e => {
          throw e;
        })
        console.log(result);
        if (result.data.status == 'SUCCEED'){
          this.$router.replace({query: { 'from-page': '/account/profile' }})
          Common.messageHandlers('line_login', { customToken: result.data.firebaseToken });
        } else {
          Login.errorLoginProcess();
        }
      }catch (e){
        
        console.error(e);
      }
    },
  }
});
</script>
